import React from "react";

// StatusBadge: shows a compact badge indicating whether the player is running.
export const StatusBadge = ({ playing }) => {
    return (
        <div>
            {playing ? (
                <div
                    className="inline-flex items-center gap-2 px-3 py-1 rounded-full font-semibold shadow-md"
                    style={{
                        backgroundColor: "var(--color-teal)",
                        color: "var(--color-white)",
                    }}
                >
                    <span
                        className="w-2 h-2 rounded-full"
                        style={{
                            backgroundColor: "var(--color-white)",
                            opacity: 0.9,
                        }}
                    />
                    <span className="text-sm">PLAYING</span>
                </div>
            ) : (
                <div
                    className="inline-flex items-center gap-2 px-3 py-1 rounded-full font-semibold border"
                    style={{
                        backgroundColor: "var(--color-lightgrey)",
                        color: "var(--color-disabled)",
                        borderColor: "var(--color-lightgrey)",
                    }}
                >
                    <span
                        className="w-2 h-2 rounded-full"
                        style={{ backgroundColor: "var(--color-disabled)" }}
                    />
                    <span className="text-sm">STOPPED</span>
                </div>
            )}
        </div>
    );
};

export default StatusBadge;
